import { useContext } from 'react';
import { assign } from 'xstate';
import { useInterpret } from '@xstate/react';
import { DataAccessContext } from '@chargify/data-access';
import { useServices } from './useServices';
import {
  ResumeSubscriptionAtEvent,
  SetErrorEvent,
  SetSubscriptionAutoResumptionDateEvent,
  resumeSubscription,
} from '../machines/resumeSubscription';

export const useSubscriptionResumeService = (
  catalogId: number,
  subscriptionId: number
) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { subscriptionsService } = useServices();

  return useInterpret(resumeSubscription, {
    services: {
      resumeSubscription: () => {
        return dataAccess.resumeSubscription(subscriptionId);
      },
      getSubscriptionResumptionConfig: () => {
        return dataAccess.getSubscriptionResumptionConfig();
      },
      updateSubscriptionAutoResumption: (
        _ctx,
        event: ResumeSubscriptionAtEvent
      ) => {
        return dataAccess.updateSubscriptionResumptionDate(
          subscriptionId,
          event.resumeDate
        );
      },
    },
    actions: {
      updateSubscription: (
        context,
        event: SetSubscriptionAutoResumptionDateEvent
      ) => {
        subscriptionsService.send({
          type: 'UPDATE_SUBSCRIPTION',
          subscriptionId,
          catalogId,
          ...event.data,
        });
      },
      setSubscriptionActive: () => {
        subscriptionsService.send({
          type: 'UPDATE_SUBSCRIPTION',
          subscriptionId,
          catalogId,
          status: 'active',
        });
      },
      setError: assign((context, event: SetErrorEvent) => {
        return {
          ...context,
          error: event.data,
        };
      }),
    },
  });
};

export type SubscriptionResumeService = ReturnType<
  typeof useSubscriptionResumeService
>;
